import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { LaravelResourceResponse } from '../../../../../../../_base-shared/contracts/laravel-response.interface';
import { Case } from '../../../../../../../_base-shared/models/Case/Case';
import { CaseCreditorPivot, CaseCreditor } from '../../../../../../../_base-shared/models/Case/CaseCreditor';
import { Creditor } from '../../../../../../../_base-shared/models/Entity/Creditor';
import { PaymentTerm } from '../../../../../../../_base-shared/models/Payment/PaymentTerm';
import { Product } from '../../../../../../../_base-shared/models/Product';
import { CaseCreditorStatus } from '../../../../../../../_base-shared/models/Status/CaseCreditorStatus';
import { Status } from '../../../../../../../_base-shared/models/Status/Status';
import { User } from '../../../../../../../_base-shared/models/User/User';
import { environment } from '../../../../../environments/environment';
import {
  ChangeCreditorStatusComponent,
} from '../../../../_shared/components/change-creditor-status/change-creditor-status.component';
import { VerifySignatureComponent } from '../../../../_shared/components/verify-signature/verify-signature.component';
import { MainGlobalEventService } from '../../../../_shared/services/main-global-event.service';
import { MiscConfigService } from '../../../config/misc-config/misc-config.service';
import { CreditorService } from '../../../creditor/creditor.service';
import { FinancialOverviewService } from '../../../payment/financial-overview.service';
import { PaymentService } from '../../../payment/payment.service';
import { CaseCreditorStatusService } from '../../../status/case-creditor/status-list/case-creditor-status.service';
import { StatusService } from '../../../status/status.service';
import { CaseCreditorService } from '../../case-creditor.service';
import { CaseDocumentService } from '../../case-document.service';
import { CaseService } from '../../case.service';
import { ProductService } from '../../product.service';
import { ProposalModalComponent } from '../case-draft/proposal-modal/proposal-modal.component';
import {
  CasePaymentPlanGeneratorComponent
} from '../case-payment/case-payment-plan-generator/case-payment-plan-generator.component';
import { AdditionalInputComponent } from './additional-input/additional-input.component';
import { CalculationModalComponent } from './calculation-modal/calculation-modal.component';
import { CaseCreditorInfoComponent } from './creditor-dialog/case-creditor-info.component';

@Component({
  standalone: false,
  selector:    'app-case-creditor-list',
  templateUrl: './case-creditor-list.component.html',
  styles:      [
    `
              .dvl-push-btn {
                box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
                line-height: 36px;
                padding: 0 16px;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 500;
              }

              .mat-icon-size {
                font-size: 25px;
                width: 25px;
                height: 25px;
              }

              .mat-mdc-form-field {
                width: 100%;
              }

              .p-r-10 {
                padding-right: 10px !important;
              }

              /* th{
                  min-width: 107px !important;
              }*/
              .amount-box-item {
                float: right;
                border: 2px solid #0a2540;
                border-radius: 10px;
                padding: 5px 15px;
                font-weight: bold;
                flex-shrink: 0;
                width: 175px;
              }

              .amount-box-fund {
                float: right;
                border: 2px solid #04abe4;
                background-color: #04abe4;
                color: white;
                border-radius: 10px;
                padding: 5px 15px;
                font-weight: bold;
                flex-shrink: 0;
                width: 175px;
              }

              .btn-primary {
                background-color: #04abe4 !important;
                color: white;
              }

              .row-is-bold {
                font-weight: bold;
              }
            `],
})
export class CaseCreditorListComponent implements OnInit {
  public authUser: User;
  public case: Case;
  public loanCreditorsForm: UntypedFormGroup;
  public loanCreditors: MatTableDataSource<CaseCreditor>;
  public settledCreditors: Array<CaseCreditor>;
  public displayedColumnsLoanCreditors: string[] = [];
  public isLoading                               = 0;
  public isFetching                              = 0;
  public isLoadingIds: Array<number>             = []; //  User to determinate in which row to show spinner
  public isPublicLoading                         = 0;
  public isPublicLoadingId: string[]             = [];
  public statuses: Array<Status>                 = [];
  public latestPropuestaPdfLocation;
  public latestPropuestaClientPdfLocation;
  public debtsSettledAmount: number;

  public totalDebt = 0;

  public allCreditors: Array<CaseCreditorPivot> = [];

  selectionUnsecured     = new SelectionModel<any>(true, []);
  selectionLoanCreditors = new SelectionModel<CaseCreditorPivot>(true, []);

  //  Enable/Disabled flags
  public isSigned = false;

  public missingAepFiles = true;
  private propuestoModelo: any;

  public unsecuredSendAepDisabled        = true;
  public unsecuredResendAepDisabled      = true;
  public unsecuredVerifyDisabled         = true;
  public unsecuredResendDisabled         = true;
  public unsecuredRecoveryDisabled       = true;
  public unsecuredProposalAccordDisabled = true;
  public isSubmitting                    = false;
  public isProductDm: boolean;
  public isProductLso: boolean;
  public storageUrl                      = environment.STORAGE_URL + '/';
  public isEditing                       = false;
  public currentRow: number;
  public isEmailEnabled                  = false;
  public isGetRightOfAccessClientEnabled = false;
  public useCreditorLoanFields           = true;
  public allCreditorsHaveProposalEmails  = true;
  public creditorWithoutProposalEmails   = [];
  public products: Array<Product>        = [];
  public selectedProduct: Product        = null;
  public disposableIncome: number;
  public targetDisposable: number;
  public paymentsMade: number;
  public totalActiveDebt: number;

  public creditorFee: number;
  public negotiationFee: number;
  public debtRequestFee: number;
  public defaultNegotiationPercent: number;
  public defaultTaxRate: number;
  public defaultFdsPercentage: number;
  public totalContribution: number;
  public settlementBalance: number;
  public caseCreditorStatuses: Array<CaseCreditorStatus>;

  public disableProposalButtons = false;

  public canSendExtrajudicial = [27, 36, 747150, 751600, 787448, 843623];

  public isLocalOrStagingEnvironment = environment.APP_ENV === 'local' || environment.APP_ENV === 'staging';

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private toast: ToastrService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private globalEventService: MainGlobalEventService,
    private caseService: CaseService,
    private creditorService: CreditorService,
    private caseCreditorService: CaseCreditorService,
    private caseDocumentService: CaseDocumentService,
    private statusService: StatusService,
    private el: ElementRef,
    private productService: ProductService,
    private financialOverviewService: FinancialOverviewService,
    private configService: MiscConfigService,
    private paymentService: PaymentService,
    private caseCreditorStatusService: CaseCreditorStatusService,
  ) {
  }

  ngOnInit(): void {
    this.globalEventService.authUser$.subscribe(user => this.authUser = user);
    this.fetchCreditorsNoFilter();
    this.route.parent.parent.paramMap.subscribe(params => {
      const caseId = +params.get('id');
      this.isLoading++;
      this.fetchCase(caseId);
      this.fetchCaseCreditorStatuses();
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected(selection, dataSource) {
    const numSelected = selection.selected.length;
    const numRows     = dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle(selection, dataSource) {
    if (this.isAllSelected(selection, dataSource)) {
      selection.clear();
      return;
    }

    selection.select(...dataSource.data);
  }

  private buildDisplayColumns(): void {
    this.displayedColumnsLoanCreditors = [
      'select', 'ref_number', 'name', 'last_paid', 'product', 'initial_balance', 'negotiated_amount', 'active_debt', 'percent_reduction',
      'creditor_lender_type', 'days_in_status', 'amount_updated_at', 'actions', 'loader'
    ];
  }

  private buildLoanCreditorsForm(): void {
    this.loanCreditorsForm = this.fb.group({
      creditor_id:       new UntypedFormControl(''),
      initial_balance:   new UntypedFormControl(''),
      last_paid:         new UntypedFormControl(''),
      debt_amount:       new UntypedFormControl(''),
      loan_id:           new UntypedFormControl(''),
      negotiated_amount: new UntypedFormControl(''),
      total_reduction:   new UntypedFormControl(''),
      percent_reduction: new UntypedFormControl(''),
      // percent_accepted:      new UntypedFormControl(''),
      sum_total_reduction:   new UntypedFormControl(''),
      debt_reduction:        new UntypedFormControl(''),
      sum_total_debt_amount: new UntypedFormControl(''),
      product_id:            new UntypedFormControl(''),
      current_creditor_id:   new UntypedFormControl(''),
      amount_updated_at:     new UntypedFormControl(''),
    });
  }

  public toggleLoanEditMode(index: number, element: CaseCreditor): void {
    this.currentRow = index;
    this.isEditing  = !this.isEditing;

    if (this.isEditing) {
      const buttons = document.querySelectorAll('.edit-button');
      buttons.forEach(button => {
        if (button.id !== index.toString()) {
          button.setAttribute('disabled', 'true');
        }
      });

      this.loanCreditorsForm.get('initial_balance').patchValue(element.initial_balance ?? element.debt_amount);
      this.loanCreditorsForm.get('last_paid').patchValue(element.last_paid);
      this.loanCreditorsForm.get('amount_updated_at').patchValue(element.amount_updated_at);
      this.loanCreditorsForm.get('debt_amount').patchValue(element.debt_amount);
      this.loanCreditorsForm.get('loan_id').patchValue(element.loan_id);
      this.loanCreditorsForm.get('product_id').patchValue(element.product_id);
      this.loanCreditorsForm.get('negotiated_amount').patchValue(element.negotiated_amount);
      this.loanCreditorsForm.get('current_creditor_id').patchValue(element.current_creditor_id);
      this.loanCreditorsForm.get('creditor_id').patchValue(element.creditor_id);
      if (element.case_creditor_status.slug === 'ds_settled' || element.case_creditor_status.slug === 'debt_zero') {
        this.loanCreditorsForm.get('negotiated_amount')?.disable();
      }
      this.el.nativeElement.querySelector('td').classList.add('.p-r-10');
    }

    if (!this.isEditing) {
      this.saveLoanCreditorData(element, this.loanCreditorsForm.getRawValue());
      this.loanCreditorsForm.get('creditor_id').patchValue(element.creditor_id);
      this.loanCreditorsForm.get('total_reduction').patchValue(element.total_reduction);
      this.loanCreditorsForm.get('percent_reduction').patchValue(element.percent_reduction);
      // this.loanCreditorsForm.get('percent_accepted').patchValue(element.percent_accepted);
      this.loanCreditorsForm.get('product_id').patchValue(this.selectedProduct.id);
      this.loanCreditorsForm.get('current_creditor_id').patchValue(element.current_creditor_id);
      this.loanCreditorsForm.get('amount_updated_at').patchValue(element.amount_updated_at);

      const loanCreditors: CaseCreditor[]      = [...this.loanCreditors.data];
      loanCreditors[index].initial_balance     = this.loanCreditorsForm.get('initial_balance').value;
      loanCreditors[index].last_paid           = this.loanCreditorsForm.get('last_paid').value;
      loanCreditors[index].debt_amount         = this.loanCreditorsForm.get('debt_amount').value;
      loanCreditors[index].loan_id             = this.loanCreditorsForm.get('loan_id').value;
      loanCreditors[index].product_id          = this.loanCreditorsForm.get('product_id').value;
      loanCreditors[index].current_creditor_id = this.loanCreditorsForm.get('current_creditor_id').value;
      loanCreditors[index].creditor_id         = this.loanCreditorsForm.get('creditor_id').value;
      loanCreditors[index].negotiated_amount   = this.loanCreditorsForm.get('negotiated_amount').value;
      loanCreditors[index].amount_updated_at   = this.loanCreditorsForm.get('amount_updated_at').value;
      this.loanCreditors                       = new MatTableDataSource<CaseCreditor>(loanCreditors);

      this.loanCreditorsForm.get('debt_reduction').patchValue(this.getTotal('percent_reduction').toFixed(2));
      this.loanCreditorsForm.get('sum_total_debt_amount').patchValue(this.getTotal('debt_amount').toFixed(2));
      this.loanCreditorsForm.get('debt_amount').patchValue(null);
      this.loanCreditorsForm.get('initial_balance').patchValue(null);
      this.loanCreditorsForm.get('last_paid').patchValue(null);
      this.loanCreditorsForm.get('loan_id').patchValue(null);
      this.loanCreditorsForm.get('product_id').patchValue(null);
      this.loanCreditorsForm.get('negotiated_amount').patchValue(null);
      this.loanCreditorsForm.get('total_reduction').patchValue(null);
      this.loanCreditorsForm.get('percent_reduction').patchValue(null);
      // this.loanCreditorsForm.get('percent_accepted').patchValue(null);
      this.loanCreditorsForm.get('current_creditor_id').patchValue(null);
      this.loanCreditorsForm.get('creditor_id').patchValue(null);
      this.loanCreditorsForm.get('amount_updated_at').patchValue(null);
      this.loanCreditorsForm.get('negotiated_amount')?.enable();
      this.loanCreditorsForm.updateValueAndValidity();
    }
  }

  private fetchCaseCreditors(): void {
    this.isFetching++;
    this.loanCreditors = new MatTableDataSource<CaseCreditor>([]);
    const relations    = ['creditor', 'product', 'case_creditor_status', 'latest_case_creditor_status_log', 'case'];

    this.caseCreditorService.getCaseCreditors(this.case.id, {type: 'unsecured', select_all: 1}, relations)
      .pipe(finalize(() => this.isFetching--))
      .subscribe(result => {
        const caseCreditors  = result.data.map(caseCreditor => {
          let activeDebt = 0;
          if (caseCreditor.case_creditor_status
            && caseCreditor.product?.slug !== 'exclude'
            && !caseCreditor.case_creditor_status.zero_active_debt) {
            activeDebt += (caseCreditor.negotiated_amount || caseCreditor.debt_amount);
          }
          return {
            ...caseCreditor,
            active_debt: activeDebt
          };
        });
        this.totalActiveDebt = caseCreditors.reduce((sum, item) => {
          return sum + (+item.active_debt || 0);
        }, 0);
        this.loanCreditors   = new MatTableDataSource<CaseCreditor>(caseCreditors);
        this.calculateDebtSettlementAmount(caseCreditors);
      });
  }

  public calculateDebtSettlementAmount(caseCreditors: Array<CaseCreditor>): void {
    this.settledCreditors   = caseCreditors.filter(caseCreditor => {
      return (
        caseCreditor.case_creditor_status?.slug === 'ds_settled' &&
        caseCreditor.product?.slug !== 'exclude' &&
        !(caseCreditor.creditor?.lender_type === 'bank' &&
          caseCreditor.creditor?.accept_debt_settlement === false
        )
      );
    });
    this.debtsSettledAmount = this.settledCreditors.reduce((sum, item) => {
      return sum + (+item.negotiated_amount || 0);
    }, 0);
    console.log(this.totalContribution);
    console.log(this.debtsSettledAmount);
    this.settlementBalance = this.totalContribution - this.debtsSettledAmount;
  }

  public clearFilters() {
    this.fetchCaseCreditors();
  }

  public clearMultiSelect($event, name) {
    $event.stopPropagation();
  }

  public verifyCreditor($event, caseCreditorId, creditorType, caseDetails: Case = null) {
    $event.preventDefault();
    console.log('caseDetails', caseDetails);
    let failure = false;
    caseDetails.contracts.forEach(contract => {
      if (contract.mandate_location == null || contract.pdf_location == null) {
        failure = true;
        Swal.fire({
          title:             'File Problem', // this.translate.instant('CASES.details.verify-creditor-error'),
          text:              'Mandate or Contract PDF is not found, please regenerate!', // this.translate.instant('CASES.details.verify-creditor-error-message'),
          icon:              'error',
          confirmButtonText: this.translate.instant('SHARED.close'),
        });
      }
    });
    if (failure) {
      return;
    }
    const caseCreditorIds = caseCreditorId.selected ? caseCreditorId.selected.map(cred => cred.id) : caseCreditorId;
    if (!!this.case.client.signature_verified_at) {
      if (creditorType === 'public_debts') {
        this.additionalInput(caseCreditorIds, creditorType);
      } else {
        this.verifySendMandates(caseCreditorIds, creditorType);
      }
    } else {
      this.verifySignature(caseCreditorIds, creditorType);
    }
  }

  public sendProposalAndAccord(caseCreditorIds: Array<number>, selection: SelectionModel<CaseCreditorPivot> = null) {
    this.isLoading++;
    this.isLoadingIds = caseCreditorIds;
    this.creditorService.sendProposalAndAcoord(this.case.id, {selected_ids: caseCreditorIds})
      .pipe(finalize(() => {
        this.isLoading--;
        this.isLoadingIds = [];
      }))
      .subscribe(
        value => {
          this.toast.success(this.translate.instant('CASES.details.send-proposal-accord-success'));
          if (selection.selected) {
            selection.clear();
          }
        },
        error => {
          if (selection.selected) {
            selection.clear();
          }
          if (error.error.errors.case.errors && error.error.errors.case.errors.length) {
            this.throwMultipleErrors(error.error.errors.case.errors);
          } else {
            this.toast.error(this.translate.instant('CASES.details.send-proposal-accord-error'));
          }
        });
  }

  public markAsVerified(id, type) {
    if (type === 'unsecured_creditors') {
      // @ts-ignore
      const item    = this.unsecuredCreditors.data.find(i => i.id === id);
      // @ts-ignore
      item.verified = 1;
    }
    if (type === 'excluded_creditors') {
      // @ts-ignore
      const item    = this.excludedCreditors.data.find(i => i.id === id);
      // @ts-
      item.verified = 1;
    }
  }

  public updateStatus(id, type, value) {
    if (type === 'secured_creditors') {
      // @ts-ignore
      const item             = this.securedCreditors.data.find(i => i.id === id);
      // @ts-ignore
      item.response_received = value;
    }
    if (type === 'unsecured_creditors') {
      // @ts-ignore
      const item             = this.unsecuredCreditors.data.find(i => i.id === id);
      // @ts-ignore
      item.response_received = value;
    }
  }

  verifySendMandates(caseCreditorId, creditorType) {
    const ids = caseCreditorId.selected ? caseCreditorId.selected.map(cred => cred.id) : caseCreditorId;
    this.isLoading++;
    this.isLoadingIds = ids;
    this.creditorService.verifySendMandates(ids[0], ids.length > 1 ? {selected_ids: ids} : null)
      .pipe(finalize(() => {
        this.isLoading--;
        this.isLoadingIds = [];
      }))
      .subscribe(
        value => {
          // @ts-ignore
          value.data.messages.map(message => {
            this.toast.success(message.message);
          });

          ids.map(id => {
            this.markAsVerified(id, creditorType);
            this.updateStatus(id, creditorType, 'mandate_sent');
          });
          if (caseCreditorId.selected) {
            caseCreditorId.clear(); //  Remove selections
          }
        },
        error => {
          if (caseCreditorId.selected) {
            caseCreditorId.clear(); //  Remove selections
          }
          if (error.error.errors.case.errors && error.error.errors.case.errors.length) {
            this.throwMultipleErrors(error.error.errors.case.errors);
          } else {
            this.toast.error(this.translate.instant('CASES.details.resend-mandates-error'));
          }
        });
  }

  sendMandatesRecoveryAgent($event, caseCreditorId): void {
    $event.preventDefault();
    const ids = caseCreditorId.selected ? caseCreditorId.selected.map(cred => cred.id) : caseCreditorId;
    this.isLoading++;
    this.isLoadingIds = ids;
    this.creditorService.sendMandatesRecoveryAgent(ids[0], ids.length > 1 ? {selected_ids: ids} : null)
      .pipe(finalize(() => {
        this.isLoading--;
        this.isLoadingIds = [];
      }))
      .subscribe(
        value => {
          // @ts-ignore
          value.data.messages.map(message => {
            this.toast.success(message.message);
          });
          if (caseCreditorId.selected) {
            caseCreditorId.clear(); //  Remove selections
          }
        },
        error => {
          if (caseCreditorId.selected) {
            caseCreditorId.clear(); //  Remove selections
          }
          if (error.error.errors.case.errors && error.error.errors.case.errors.length) {
            this.throwMultipleErrors(error.error.errors.case.errors);
          } else {
            this.toast.error(this.translate.instant('CASES.details.email-sent-error'));
          }
        });
  }

  verifySignature(caseCreditorId, creditorType) {
    const dialogRef = this.dialog.open(VerifySignatureComponent, {
      width:  '50%',
      height: '50%',
      data:   {
        case:           this.case,
        verifyCreditor: true,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.data.message) {
          if (creditorType === 'public_debts') {
            this.additionalInput(caseCreditorId, creditorType);
          } else {
            this.verifySendMandates(caseCreditorId, creditorType);
          }
          // this.updateSignatureVerification.emit(1);
        }
      }
    });
  }

  additionalInput(debtIds, creditorType) {
    const ids              = debtIds.selected ? debtIds.selected.map(cred => cred.id) : debtIds;
    this.isPublicLoading   = 1;
    this.isPublicLoadingId = ids;

    const dialogRef = this.dialog.open(AdditionalInputComponent, {
      width:  '50%',
      height: '50%',
      data:   {
        case: this.case,
        debtIds,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.data.message) {
          ids.map(id => {
            this.markAsVerified(id, creditorType);
          });
          this.isPublicLoading   = 0;
          this.isPublicLoadingId = [];
          if (debtIds.selected) {
            debtIds.clear(); //  Remove selections
          }
        }
      } else {
        this.isPublicLoading   = 0;
        this.isPublicLoadingId = [];
        if (debtIds.selected) {
          debtIds.clear(); //  Remove selections
        }
      }
    });
  }

  public changeStatus($event: MouseEvent, selection = null, type: string): void {
    $event.preventDefault();
    const idsArr    = this.selectionLoanCreditors.selected.map(cred => cred.id);
    let ids;
    let changeAll = 0;
    if (type === 'public_debts') {
      ids = selection.selected ? selection.selected.map(cred => cred.id) : selection;
    } else {
      ids = selection.selected ? selection.selected.map(cred => cred.id) : selection;
    }

    if (idsArr.length > 0) {
      changeAll = 1;
      ids       = idsArr;
    }

    const dialogRef = this.dialog.open(ChangeCreditorStatusComponent, {
      width:  '30%',
      height: 'fit-content',
      data:   {
        case: this.case,
        ids,
        type,
        changeAll,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (selection.selected) {
        selection.clear(); //  Remove selections
      }
      if (result) {
        ids.map(id => {
          this.updateStatus(id, type, result);
        });
      }
      this.fetchCaseCreditors();
    });
  }

  checkIfDisabled(selection, type: string) {
    if (type === 'unsecured') {
      //  Used to Disable/Enable `verify and send mandate` action
      //  Check if there is selection and if selected items are verified
      //  If there are verified debt selected we disable action
      this.unsecuredVerifyDisabled = !!(selection.source.selected.length === 0 ||
        selection.source.selected.filter(cred => cred.verified === 1).length);

      //  Used to Disable/Enable `send mandate recovery` action
      this.unsecuredRecoveryDisabled = !!(selection.source.selected.length === 0 ||
        selection.source.selected.filter(cred => cred.recovery_creditor_id).length);

      //  Used to Disable/Enable `resend mandate` action
      //  Check if there is selection and if selected items are not verified
      this.unsecuredResendDisabled = !!(selection.source.selected.length === 0 ||
        selection.source.selected.filter(cred => cred.verified !== 1).length);

      //  Used to Disable/Enable `send aep` action
      //  Check if there is selection and if can send aep email
      this.unsecuredSendAepDisabled = !!(selection.source.selected.length === 0 ||
        (this.case.legal_documents.filter(file => file.document_type === 'aep').length === 0 && // No `aep` files
          // No `aep-reg` files uploaded for client
          (this.case.legal_documents.filter(
              file => file.document_type === 'aep-reg' && file.uploaded_by === 'client').length === 0 ||
            // No `aep-reg` files uploaded for partner
            this.case.legal_documents.filter(
              file => file.document_type === 'aep-reg' && file.uploaded_by === 'partner').length === 0)) ||
        selection.source.selected.filter(cred => cred.aep_sent === 1).length);

      //  Used to Disable/Enable `resend aep` action
      //  Check if there is selection and if can send aep email
      this.unsecuredResendAepDisabled = !!(selection.source.selected.length === 0 ||
        (this.case.legal_documents.filter(file => file.document_type === 'aep').length === 0 && // No `aep` files
          // No `aep-reg` files uploaded for client
          (this.case.legal_documents.filter(
              file => file.document_type === 'aep-reg' && file.uploaded_by === 'client').length === 0 ||
            // No `aep-reg` files uploaded for partner
            this.case.legal_documents.filter(
              file => file.document_type === 'aep-reg' && file.uploaded_by === 'partner').length === 0)) ||
        selection.source.selected.filter(cred => cred.aep_sent !== 1).length);

      //  Used to Disable/Enable `send proposal and accord` action
      this.unsecuredProposalAccordDisabled = !!(selection.source.selected.length === 0 || !this.isSigned ||
        selection.source.selected.filter(cred => !cred.proposal_location).length);

      this.isEmailEnabled                  = this.selectionUnsecured.selected.every(
        creditor => creditor.total_repaid > creditor.initial_balance);
      this.isGetRightOfAccessClientEnabled = this.selectionUnsecured.selected.every(
        creditor => (creditor.ownership === 'applicant' ||
          creditor.ownership ===
          'joint'));
    }
  }

  private parseValidationErrors(errorResponse: any) {
    const error = errorResponse.error;
    if (+error.code === 422 && error.errors) {
      for (const [key, value] of Object.entries(error.errors)) {
        const valueArray = value as any;
        valueArray.forEach(e => this.toast.error(e));
      }
    }
  }

  public returnLenderType(lenderType: 'standard' | 'high_interest' | 'collections') {
    const types = {
      collections:   '',
      standard:      '',
      high_interest: '#ffff63',
    };
    return types[lenderType];
  }

  public saveLoanCreditorData(element, formValue): void {
    // if formvalue for product is empty, show error
    if (!formValue.product_id) {
      this.toast.error(this.translate.instant('CASE_CREDITOR.select_product'));
      return;
    }
    formValue.percent_reduction = ((element.initial_balance - formValue.negotiated_amount) / element.initial_balance) * 100;
    this.caseCreditorService.updateCaseCreditor(this.case.id, element.id, formValue)
      .subscribe(res => {
        this.fetchCaseCreditors();
        this.toast.success(this.translate.instant('SHARED.success'));
      }, err => {
        if (err.error?.message) {
          this.toast.error(err.error.message);
        } else {
          this.toast.error(this.translate.instant('SHARED.error'));
        }
        this.fetchCaseCreditors();
      });
  }

  private fetchStatuses(): void {
    this.isLoading++;
    this.statusService.index().pipe(finalize(() => this.isLoading--)).subscribe(result => {
        this.statuses = result.data;
      },
    );
  }

  public sendCase(clientCase: Case, projectId: string): void {
    Swal.fire({
      title:             this.translate.instant('CASE_CREDITOR.refer_case.heading'),
      text:              this.translate.instant('CASE_CREDITOR.refer_case.warning-text') + ' ' + projectId.toUpperCase(),
      icon:              'warning',
      showCancelButton:  true,
      confirmButtonText: 'OK',
      cancelButtonText:  this.translate.instant('SHARED.cancel'),
    }).then(res => {
      if (res.isConfirmed) {
        this.isLoading++;
        this.caseService.sendCase(clientCase.id, {destination_project_id: projectId})
          .pipe(finalize(() => this.isLoading--))
          .subscribe(result => {
              if (projectId === 'dvl') {
                this.case.dvl_ref_number = result.data.case.dvl_ref_number;
              }

              if (projectId === 'epi') {
                this.case.epi_ref_number = result.data.case.epi_ref_number;
              }

              this.toast.success('Sent case successfully');
            },
            error => {
              let errorMessage = 'Failed to send case';
              if (error.error.status === 422) {
                const parsedError = JSON.parse(error.error.message);
                errorMessage      = parsedError[Object.keys(parsedError)[0]][0];
              }
              errorMessage = errorMessage.replace('.', ' ');
              this.toast.error(errorMessage);
            },
          );
      }
    });
  }

  private throwMultipleErrors(errorsArray: Array<string> | Array<{
    errors: string, id: number, name: string,
    reference_number: string
  }>): void {
    errorsArray.forEach(caseCreditorError => {
      this.toast.error(caseCreditorError, '',
        {disableTimeOut: true});
    });
  }

  public generateProposal(): void {

    // check if the income and expenses are filled and not zero before generating proposal
    // if (this.case.income === 0 || this.case.expenses === 0) {
    //   this.toastr.error(this.translate.instant('CASES.single.draft.proposal.income_expenses_zero'));
    //   return;
    // }
    // get the data from financialoverviewservice
    this.financialOverviewService.fetchLatest(this.case.id).subscribe(
      res => {
        if (res.data.income === 0 || res.data.expenses === 0) {
          Swal.fire({
            title:             'Error, Incomes or Expenses are zero',
            icon:              'error',
            showCancelButton:  false,
            confirmButtonText: this.translate.instant('SHARED.close'),
          });
          return false;
        } else {

          const dialogRef = this.dialog.open(ProposalModalComponent, {
            width:  '90%',
            height: '85%',
            data:   {
              case:          this.case,
              disableButton: this.disableProposalButtons
            },
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result && !result.dismissed && result.data) {
              this.case.proposal = result.data;
              this.fetchCase(this.case.id);
            }
          });
        }

        // this.openProposalModal();
      },
      err => {
        this.toastr.error(this.translate.instant('CASES.single.draft.proposal.income_expenses_zero'));
      }
    );
  }

  public previewProposal(clientRole: string): void {
    // Open swal dialog asking which proposal to preview either dmp or ds with buttons as html with actions when clicked
    const swalHtml = `
      <table style="text-align: left;" width="100%">
        <tr>
          <td width="80%">${ this.translate.instant('CASES.proposal.prop_dm') }</td>
          <td width="20%" style="text-align: right;"><button id="dmp" class="btn btn-primary" disabled>${ this.translate.instant('CASES.proposal.go') }</button></td>
        </tr>
        <tr>
          <td>${ this.translate.instant('CASES.proposal.prop_ds') }</td>
          <td style="text-align: right;"><button id="ds" class="btn btn-primary">${ this.translate.instant('CASES.proposal.go') }</button></td>
        </tr>
      </table>
    `;

    Swal.fire({
      title:             this.translate.instant('CASES.proposal.preview'),
      html:              swalHtml,
      showCancelButton:  true,
      confirmButtonText: this.translate.instant('SHARED.cancel'),
      showCloseButton:   true,
      showConfirmButton: false,
    });

    document.getElementById('dmp').addEventListener('click', () => {
      const location = (environment.APP_URL.replace('app.', 'clientes.')) +
        '/public/sign-proposal?uuid=' + this.case.uuid + '&sign=' + clientRole;
      window.open(location, '_blank');
      Swal.close();
    });

    document.getElementById('ds').addEventListener('click', () => {
      const location = (environment.APP_URL.replace('app.', 'clientes.')) +
        '/public/sign-proposal?uuid=' + this.case.uuid + '&sign=' + clientRole + '&ds=1';
      window.open(location, '_blank');
      Swal.close();
    });
  }

  public sendProposalToClient(): void {
    this.caseDocumentService.sendProposalToClient(this.case.id).subscribe(res => {
      this.toastr.success(this.translate.instant('CASES.single.draft.proposal.send_proposal_to_client.response.success'));
    }, err => {
      this.toastr.error(this.translate.instant('SHARED.went-wrong'));
    });
  }

  public requestProposalSignature(): void {
    const swalHtml = `
      <table style="text-align: left;" width="100%">
        <tr>
          <td width="80%">${ this.translate.instant('CASES.proposal.prop_dm') }</td>
          <td width="20%" style="text-align: right;"><button id="dmp_1" class="btn btn-primary" disabled>${ this.translate.instant('CASES.proposal.go') }</button></td>
        </tr>
        <tr>
          <td>${ this.translate.instant('CASES.proposal.prop_ds') }</td>
          <td style="text-align: right;"><button id="ds_1" class="btn btn-primary">${ this.translate.instant('CASES.proposal.go') }</button></td>
        </tr>
      </table>
    `;

    Swal.fire({
      title:             this.translate.instant('CASES.proposal.request'),
      html:              swalHtml,
      showCancelButton:  true,
      confirmButtonText: this.translate.instant('SHARED.cancel'),
      showCloseButton:   true,
      showConfirmButton: false,
    });

    document.getElementById('dmp_1').addEventListener('click', () => {
      this.caseDocumentService.requestProposalSignature(this.case.id, 'proposal').subscribe(res => {
        this.toastr.success(this.translate.instant('CASES.single.draft.proposal.request_signature.response.success'));
      }, err => {
        this.toastr.error(this.translate.instant('SHARED.went-wrong'));
      });
      Swal.close();
    });

    document.getElementById('ds_1').addEventListener('click', () => {
      this.caseDocumentService.requestProposalSignature(this.case.id, 'ds').subscribe(res => {
        this.toastr.success(this.translate.instant('CASES.single.draft.proposal.request_signature.response.success'));
      }, err => {
        this.toastr.error(this.translate.instant('SHARED.went-wrong'));
      });
      Swal.close();
    });
  }

  public sendProposalToCreditors(caseId: number): void {
    if (!this.case.client.id_card) {
      this.toastr.error(this.translate.instant('CLIENT.auth-payment.dni_required'));
      return;
    }
    this.caseDocumentService.sendProposalToCreditors(this.case.id).subscribe(res => {
      this.toastr.success(this.translate.instant('CASES.single.draft.proposal.proposal_sent_to_creditors'));
    }, err => {
      this.toastr.error(this.translate.instant('SHARED.went-wrong'));
    });
  }

  public getTotal(columnName: string): number {
    let total = 0;

    if (this.loanCreditors) {
      if (columnName === 'debt_amount') {
        this.loanCreditors.data.forEach(data => {
          if (data.product_id !== 18) {
            total += +(data.debt_amount || 0);
          }
        });
      }

      if (columnName === 'negotiated_amount') {
        this.loanCreditors.data.forEach(data => {
          if (data.product_id !== 18) {
            total += +(data.negotiated_amount || 0);
          }
        });
      }

      if (columnName === 'initial_balance') {
        this.loanCreditors.data.forEach(data => {
          if (data.product_id !== 18) {
            total += +(data.initial_balance || 0);
          }
        });
      }

      if (columnName === 'active_debt') {
        this.loanCreditors.data.forEach(data => {
          total += +data.active_debt;
        });
      }

      if (columnName === 'total_reduction') {
        let negotiatedAmount = 0;
        let debtAmount       = 0;
        this.loanCreditors.data.forEach(data => {
          negotiatedAmount += +data.negotiated_amount;
          debtAmount += +(data.debt_amount || 0);
        });

        if (debtAmount === 0) {
          total = 0;
        } else {
          total = debtAmount - negotiatedAmount;
        }
      }

      if (columnName === 'percent_reduction') {
        let debtAmount       = 0;
        let negotiatedAmount = 0;

        this.loanCreditors.data.forEach(data => {
          debtAmount += +(data.initial_balance || 0);
          negotiatedAmount += +data.negotiated_amount;
        });
        if (debtAmount === 0) {
          total = 0;
        } else {
          total = +(+(+(debtAmount - negotiatedAmount) / debtAmount) * 100);
        }
      }

      return total;
    }
  }

  private fetchProducts() {
    this.isLoading++;
    this.productService.index({select_all: 1}).pipe(finalize(() => this.isLoading--)).subscribe(
      result => this.products = result.data
    );
  }

  // return product name by id
  public getProductName(id: number): string {
    return this.products.find(product => product.id === id)?.name;
  }

  creditorDetails(creditor: Creditor, element): void {
    console.log(creditor);
    this.dialog.open(CaseCreditorInfoComponent, {
      width: 'fit-content',
      data:  creditor,
    });
  }


  private fetchCreditorsNoFilter() {
    this.isLoading++;
    this.creditorService.index({select_all: 1, active: 1}).pipe(finalize(() => this.isLoading--))
      .subscribe(result => {
          this.allCreditors = result.data;
        },
        err => console.error(err)
      );
  }

  public getUnsecuredCreditorName(id: number): string {
    return this.allCreditors.find(creditor => creditor.id === id)?.name;
  }

  public getResponseReceivedStatus(creditors): string {
    let percent      = 0;
    let acceptedDebt = 0;
    this.loanCreditors.data.forEach(creditor => {
      if ((creditor.case_creditor_status.slug == 'dm_accepted' || creditor.case_creditor_status.slug == 'dm_signed')) {
        acceptedDebt += +creditor.debt_amount;
      }
    });

    percent = (acceptedDebt / this.totalDebt) * 100;
    return percent.toFixed(2);
  }

  public getDebtPercentage(creditor): number {
    // if(creditor.pivot.product_id === 15) {
    return (creditor.debt_amount / this.totalDebt) * 100;
    // }
  }

  public openPaymentPlanGenerationModal(additional_data) {
    const dialogRef = this.dialog.open(CasePaymentPlanGeneratorComponent, {
      width: '60%',
      data:  {
        case:     this.case,
        creditor: additional_data
      },
    });
  }

  public requestDebtSettlement(caseCreditor: CaseCreditor | any, client: Case) {
    // if the settlement_balance is not sufficient, show error

    this.configService.getConfigData().subscribe(next => {
      this.defaultNegotiationPercent = next.data.find(obj => obj.key === 'ds_reduction_percent').value;
      this.defaultTaxRate            = next.data.find(obj => obj.key === 'default_iva_rate').value;
      this.defaultFdsPercentage      = next.data.find(obj => obj.key === 'ds_default_fds_reduction').value;
      // cast this.defaultFdsPercentage to number
      this.defaultFdsPercentage      = +this.defaultFdsPercentage;

      // calculate reduction percentage
      const reductionPercentage = ((caseCreditor.initial_balance - caseCreditor.negotiated_amount) / caseCreditor.initial_balance) * 100;

      console.log((this.case.settlement_balance > caseCreditor.negotiated_amount));
      console.log((reductionPercentage > this.defaultFdsPercentage));
      const fdsInsuffcient        = (this.case.settlement_balance > caseCreditor.negotiated_amount) ? '' : 'Settlement balance is insufficient';
      const reductionInsufficient = (reductionPercentage > this.defaultFdsPercentage) ? '' : 'Reduction percentage is insufficient';

      // if ((this.case.settlement_balance < creditor.pivot.current_balance) || (reductionPercentage > this.defaultFdsPercentage) !== true) {
      // if ((this.case.settlement_balance > creditor.pivot.negotiated_amount) === true || (reductionPercentage > this.defaultFdsPercentage) !== true) {
      //     Swal.fire({
      //         title: 'Error',
      //         html: fdsInsuffcient + '<br>' + reductionInsufficient,
      //         icon: 'error',
      //         showCancelButton: false,
      //         confirmButtonText: 'Close',
      //     });
      //     return;
      // }

      this.creditorFee    = caseCreditor.negotiated_amount;
      this.negotiationFee = ((caseCreditor.initial_balance - caseCreditor.negotiated_amount) * this.defaultNegotiationPercent / 100);
      this.debtRequestFee = +this.creditorFee + +this.negotiationFee;

      const html       = `
          <table style="text-align: left;">
              <tr>
                  <td>${ this.translate.instant('CREDITORS.debt-settlement-request.negotiation-fee') }: ${ this.negotiationFee }</td>
              </tr>
              <tr>
                  <td>${ this.translate.instant('CREDITORS.debt-settlement-request.total-quick-win') }: ${ this.debtRequestFee }</td>
              </tr>
          </table>
        `;
      let buttonText = this.translate.instant('CREDITORS.debt-settlement-request.actions.send');
      if (caseCreditor.case_creditor_status.slug === 'ds_settlement_requested') {
        buttonText = this.translate.instant('CREDITORS.debt-settlement-request.actions.accept');
      }

      Swal.fire({
        title:              this.translate.instant('CREDITORS.debt-settlement-request.title') + ': ' + caseCreditor.creditor.name,
        html,
        showCancelButton:   true,
        confirmButtonText:  buttonText,
        confirmButtonColor: '#886ab5',
        cancelButtonText:   this.translate.instant('SHARED.cancel'),
      }).then(res => {
        if (res.isConfirmed) {
          this.isLoading++;
          const data                   = {};
          const status                 = this.caseCreditorStatuses.find(status => status.slug === 'ds_settlement_requested');
          // @ts-ignore
          data.case_creditor_status_id = status.id;
          // @ts-ignore
          data.product_id              = 19;

          if (caseCreditor.case_creditor_status.slug === 'ds_settlement_requested') {
            // @ts-ignore
            data.case_creditor_status_id = status.id;
          }

          this.caseCreditorService.updateCaseCreditor(this.case.id, caseCreditor.id, data)
            .pipe(finalize(() => this.isLoading--))
            .subscribe(
              value => {
                this.toast.success(this.translate.instant('CASES.details.change-status-success'));
                this.fetchCaseCreditors();
                Swal.close();
              },
              error => {
                if (error.error?.data?.message) {
                  this.toast.error(error.error.data.message);
                } else {
                  this.toast.error(this.translate.instant('CASES.details.change-status-error'));
                }
              });
        }
      });
    });
  }

  public getTranslatedCaseCreditorStatus(creditor): string {
    if (creditor.case_creditor_status) {
      return (this.authUser.locale === 'en') ? creditor.case_creditor_status.name_en : creditor.case_creditor_status.name_es;
    }
  }

  public showInfo(creditor: CaseCreditorPivot | any) {
    const currentCreditorName  = creditor.name;
    const originalCreditorName = this.getUnsecuredCreditorName(creditor.current_creditor_id);

    const swalString = `
      <table style="text-align: left; ">
          <tr>
              <td style="white-space: nowrap;">${ this.translate.instant('CASE_CREDITOR.model.relations.current_creditor') }:</td>
              <td style="padding-left:10px;white-space: nowrap">${ currentCreditorName }</td>
          </tr>
          <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr>
              <td style="white-space: nowrap;">${ this.translate.instant('CASE_CREDITOR.model.relations.original_creditor') }:</td>
              <td style="padding-left:10px;white-space: nowrap">${ originalCreditorName }</td>
          </tr>
      </table>
    `;
    Swal.fire({
      title:             this.translate.instant('CASE_CREDITOR.info.creditor_info'),
      html:              swalString,
      showCancelButton:  false,
      width:             '650px',
      confirmButtonText: this.translate.instant('SHARED.close'),
    });
  }

  public isElementRestricted() {

    if (!this.case || !this.case.status_id) {
      return false;
    }

    const enabledRoles         = environment.ALLOW_CASES_ROLES_IDS;
    const enabledStatusId      = environment.BLOCK_CASES_STATUS_IDS;
    const enabledDepartmentsId = environment.ALLOW_CASES_DEPARTMENTS_IDS;

    const isDepartmentAllowed = this.authUser.departments.some(department =>
      enabledDepartmentsId.includes(department.id)
    );

    if (
      !enabledStatusId.includes(this.case.status_id) ||
      enabledRoles.includes(this.authUser.role_id) ||
      isDepartmentAllowed
    ) {
      return true;
    }
    return false;
  }

  public sendExtrajudicialClaim(selectedCaseCreditors): void {
    const selectedIds = selectedCaseCreditors.selected ?
      selectedCaseCreditors.selected.map(cred => cred.id) :
      selectedCaseCreditors;
    this.isLoading++;
    this.isLoadingIds = selectedIds;

    this.creditorService.sendExtrajudicialClaim(this.case.id, {selected_ids: selectedIds})
      .pipe(finalize(() => {
        this.isLoading--;
        this.isLoadingIds = [];
        if (selectedCaseCreditors.selected) {
          selectedCaseCreditors.clear(); //  Remove selections
        }
      }))
      .subscribe(
        value => {
          this.toast.success(this.translate.instant('SHARED.success'));
        },
        error => {
          if (error) {
            this.throwMultipleErrors(error.error.errors.case.errors);
          } else {
            this.toast.error(this.translate.instant('SHARED.error'));
          }
        });
  }

  private checkProposalSigned(caseData: Case) {
    if (caseData.proposal_documents) {
      caseData.proposal_documents.forEach(document => {
        if (document.client_signature) {
          this.disableProposalButtons = true;
        }
        this.disableProposalButtons = this.isElementRestricted();
      });
    }
  }

  private fetchCase(caseId: number) {
    this.caseService.get(caseId, ['product', 'proposal_documents.client_signature', 'payments']).pipe(finalize(() => this.isLoading--)).subscribe(result => {
      this.isLoading++;
      this.paymentsMade = result.data.payments.reduce((acc, payment) => acc + payment.amount, 0);
      this.checkProposalSigned(result.data);
      this.isProductDm           = result.data.product?.group_slug === 'dmp';
      this.isProductLso          = result.data.product?.group_slug === 'lso';
      this.useCreditorLoanFields = true;
      this.caseDocumentService.indexCaseDocuments(caseId)
        .pipe(finalize(() => this.isLoading--))
        .subscribe(res => {
          this.case         = res.data;
          this.case.product = result.data.product;
          this.fetchDebtPlanFees(this.case.id);
          this.fetchStatuses();
          this.fetchProducts();
          this.buildDisplayColumns();
          this.buildLoanCreditorsForm();
          this.caseDocumentService.index(caseId, ['legal_documents'])
            .pipe(finalize(() => this.isLoading--))
            // tslint:disable-next-line:no-shadowed-variable
            .subscribe(res => {
              this.case.legal_documents             = res.data.legal_documents;
              this.missingAepFiles                  = !!(this.case.legal_documents.filter(
                  file => file.document_type === 'aep').length === 0 &&
                (this.case.legal_documents.filter(
                    file => file.document_type === 'aep-reg' && file.uploaded_by === 'client').length === 0 ||
                  this.case.legal_documents.filter(
                    file => file.document_type === 'aep-reg' && file.uploaded_by === 'partner').length === 0));
              this.latestPropuestaPdfLocation       = this.case.creditor_proposal_pdf?.proposal_location;
              this.latestPropuestaClientPdfLocation = this.case.proposal_pdf?.path;
            });
          this.isLoading++;
          this.caseDocumentService.showPropuestoModelo(caseId)
            .pipe(finalize(() => this.isLoading--))
            // tslint:disable-next-line:no-shadowed-variable
            .subscribe(res => {
              this.propuestoModelo = res.data;
              if (this.propuestoModelo) {
                this.isSigned = this.case.joint_application ?
                  !!(this.propuestoModelo.signature && this.propuestoModelo.signature_partner) :
                  !!this.propuestoModelo.signature;
              } else {
                this.isSigned = false;
              }
            });
          this.selectionUnsecured.changed.subscribe(next => {
            this.checkIfDisabled(next, 'unsecured');
          });
          this.loanCreditorsForm.get('product_id').valueChanges.subscribe(value => {
            this.selectedProduct = this.products.find(product => product.id === value);
          });

          this.financialOverviewService.fetchLatest(this.case.id).subscribe(overview => {
            this.targetDisposable = overview.data.target_monthly_payment;
            this.disposableIncome = (overview.data.income - overview.data.expenses);
            if (this.disposableIncome) {
              console.log('disposableIncome', this.disposableIncome);
            }
          });
        });
    });
  }

  public getDaysInStatus(element): number {
    if (element.latest_case_creditor_status_log && element.latest_case_creditor_status_log.created_at) {
      return Math.ceil(DateTime.fromISO(element.latest_case_creditor_status_log.created_at).diffNow('days').negate().as('days'));
    }
  }

  private fetchDebtPlanFees(caseId: number): void {
    const data = {
      case_id:                caseId,
      select_all:             1,
      payment_plan_type_slug: 'debt_plan_fee',
    };
    this.isLoading++;
    this.paymentService.getInstallmentFees(caseId, data, [])
      .pipe(finalize(() => this.isLoading--))
      .subscribe(
        (result: LaravelResourceResponse<Array<PaymentTerm>>) => {
          this.totalContribution = result.data.reduce((sum, item) => {
            return sum + (item.amount_paid || 0);
          }, 0);
          this.fetchCaseCreditors();
        },
        err => console.error(err),
      );
  }

  private fetchCaseCreditorStatuses(): void {
    this.isLoading++;
    const data = {
      'append[]': ['name'],
      select_all: 1,
    };
    this.caseCreditorStatusService.index(data).pipe(finalize(() => this.isLoading--))
      .subscribe(res => {
        this.caseCreditorStatuses = res.data;
      });
  }

  public openCalculationModal(caseCreditor: CaseCreditor, $event: Event): void {
    this.dialog.open(CalculationModalComponent, {
      width: 'fit-content',
      data: {
        caseCreditor,
        settlementBalance: this.settlementBalance,
      }
    });
  }

}
